export interface ScanResult {
  name: string;
  status: 'pass' | 'fail' | 'warn' | 'info';
  message: string;
  autoFixed?: boolean;
  details?: string;
}

export interface ScanSummary {
  scanName: string;
  timestamp: Date;
  results: ScanResult[];
  passCount: number;
  failCount: number;
  warnCount: number;
  infoCount: number;
}

export function createScanSummary(scanName: string, results: ScanResult[]): ScanSummary {
  return {
    scanName,
    timestamp: new Date(),
    results,
    passCount: results.filter(r => r.status === 'pass').length,
    failCount: results.filter(r => r.status === 'fail').length,
    warnCount: results.filter(r => r.status === 'warn').length,
    infoCount: results.filter(r => r.status === 'info').length,
  };
}
